import React from "react";
import SideNavbar from "../../../../components/sideNavbar";
import Header from "../../../../components/header";
import { Box } from "@mui/material";
import DealDetailView from "./components/Board/DealDetailView";

const EditLeads = () => {
  return (
    <div>
      <Box>
        <Box sx={{ ml: { xs: "0px", md: "280px" } }}>
          <SideNavbar />
          <Box sx={{ display: { xs: "none", md: "initial" } }}>
            <Header title={"Lead Pipeline"} />
          </Box>

          <Box
            component="main"
            sx={{
              width: "100%",
            }}
          >
            <DealDetailView />
          </Box>
        </Box>
      </Box>
    </div>
  );
};

export default EditLeads;
